import Vue from 'vue'
import LazyComponent from 'v-lazy-component'

Vue.use(LazyComponent)
